// extracted by mini-css-extract-plugin
export default {"colorViolet":"#080837","termsAndConditionsModal":"Tf4wZyZonmGZRVOKcaOf","termsAndConditions":"IBbie3WtRoevAcUQ8Z7A","title":"HVQu6gPeqPMIfNMEClMS"};